import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "";
export const method = "POST";
export const operationId = "workwearExpressBasketCartManagementV1SwapCustomerCartsPost";
export const path = "/V1/cart/swap/{guestCartId}";
export interface PathParams {
    guestCartId: string;
}
export type Response = Response200 | Response401 | ResponseDefault;
export type Response200 = void;
export type Response401 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "postJSON">;
export function execute(pathParams: PathParams, effects: MinimalEffects): Observable<Response200> {
    return effects.postJSON(effects.apiUrl(operationId)(path, pathParams), null, effects.restHeaders({})) as any;
}
